import { FileTextOutlined } from "@ant-design/icons"
import { Button } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface SharedDocumentRowProps {
  fileName: React.ReactNode
  projectName?: React.ReactNode
  sharedByLabel: React.ReactNode
  href: string
  compact?: boolean
}

/** A file row — Documents' full list and Home's "Recent documents" both
 * render this, so a document reads identically wherever it appears:
 * filename, then project + who shared it, with one explicit Open action
 * rather than the whole row silently acting as a link. */
export function SharedDocumentRow({
  fileName,
  projectName,
  sharedByLabel,
  href,
  compact
}: SharedDocumentRowProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-between gap-3 py-2.5 first:pt-0 last:pb-0">
      <div className="flex min-w-0 items-center gap-2.5">
        <FileTextOutlined className="shrink-0 text-gray-400" />
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-gray-800">{fileName}</p>
          <p className="truncate text-xs text-gray-500">
            {projectName && <>{projectName} · </>}
            {sharedByLabel}
          </p>
        </div>
      </div>
      <Button
        size={compact ? "small" : "middle"}
        type="text"
        href={href}
        target="_blank"
        rel="noreferrer"
        className="shrink-0 text-primary"
      >
        {t("portal.documents.open")}
      </Button>
    </div>
  )
}
